import { FC } from 'react'
import { useField } from 'react-final-form'
import isEmail from 'validator/lib/isEmail'

import TextField, {
  Props as TextFieldProps,
} from '~/form/components/molecules/TextField'

type Props = Pick<TextFieldProps, 'isConfirm' | 'required'>

const NAME = 'mailAddress'

const MailAddressField: FC<Props> = (props) => {
  const {
    input: { value },
  } = useField(NAME)

  if (props.isConfirm && !value) return null

  return (
    <TextField
      type='email'
      name={NAME}
      ariaLabel='メールアドレス'
      label='メールアドレス'
      placeholder='okanechips@mei-kyu.com'
      validate={(value) => {
        if (!value) return
        if (!isEmail(value)) {
          return `メールアドレスの形式に誤りがあります`
        }
      }}
      {...props}
    />
  )
}

MailAddressField.displayName = 'mailAddress'

export default MailAddressField
